<template>
  <div class="query-result">
    <h2 class="query-result__headline">
      Query result

      <div class="query-result__duration" v-if="localDuration">
        {{ formattedDuration }} ms
      </div>
    </h2>

    <div
      class="query-result__result"
      v-html="localResult" />
  </div>
</template>

<script>
export default {
  data() {
    return {
      localResult: "",
      localDuration: null
    }
  },
  props: {
    result: String,
    duration: {
      type: Number,
      default: 0
    }
  },
  computed: {
    formattedDuration() {
      return Math.round(this.localDuration);
    }
  },
  watch: {
    result(newVal, oldVal) {
      this.localResult = newVal;
    },
    duration(newVal, oldVal) {
      this.localDuration = Math.round(newVal, 2);
    }
  },
  mounted() {
    this.localResult = this.result;
    this.localDuration = Math.round(this.duration, 2);
  }
}
</script>

<style lang="scss">
.query-result {
  &__headline {
    position: relative;
    width: 100%;
    margin-bottom: $px16;
  }

  &__result {
    width: 100%;
    max-height: 500px;
    overflow: auto;

    border-radius: $px4;
    border: $px1 solid $grey-9;

    font-size: 14px;

    &::-webkit-scrollbar {
      width: $px8;
      height: $px8;
    }

    &::-webkit-scrollbar-thumb {
      border-radius: $px4;

    	background-color: $grey-8;
    }

    &--scrolled {
      table {
        thead {
          th {
          }
        }
      }
    }
  }

  &__duration {
    position: absolute;
    bottom: 0;
    right: 0;

    @include font-small;
    text-align: right;
  }
}
</style>
